export default __webpack_public_path__ + "static/art-pt1-homeworld-6800c0f4617a338fdb27062c71c75f08.jpg";